// extracted by mini-css-extract-plugin
module.exports = {"tabs":"buttonTabs_tabs__RWQWZ"};